"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var angular = require("angular");
var table_input_logic_1 = require("./table-input.logic");
var basic_table_component_1 = require("../basic-component/basic-table.component");
var history_modal_component_1 = require("./history-modal/history-modal.component");
var so_rich_text_box_component_1 = require("../../../components/so-rich-text-box/so-rich-text-box.component");
require('./table-input.component.css');
var COMPONENT_NAME = 'smartorg.r6.acts.tableInput2';
var TableInputComponent = /** @class */ (function () {
    function TableInputComponent($scope, $timeout, uiGridEditConstants) {
        var _this = this;
        var rootScope = $scope.$root;
        this.showAlert = function (type, title, message) {
            $scope.$emit('workbench:alert', { type: type, title: title, message: message });
        };
        this.reloadData = function () { return $scope.$emit('workbench:reloadAction'); };
        this.lastUpdated = function () { return $scope.$emit('workbench:last_updated', { nodeID: _this.node._id }); };
        this.updateNodeIsDataValid = function () { return $scope.$emit('workbench:update_isDataValid', {
            nodeIdList: [_this.node._id],
            isDataValid: _this.isCommonData !== 'true'
        }); };
        this.setGlobalDirty = function (dirty) {
            rootScope.smartorgDirty = dirty;
        };
        $scope.$on('command:TABLE_INPUT', function (event, args) {
            _this.loading = true;
            _this.cleanup();
            $timeout(function () {
                try {
                    _this.loadTable(args, uiGridEditConstants);
                    _this.menu = _this.getMenu();
                }
                catch (err) {
                    _this.showAlert('danger', "Error!", err);
                }
                finally {
                    _this.loading = false;
                }
            });
        });
    }
    TableInputComponent.prototype.$onDestroy = function () {
        this.destroyed = true;
    };
    TableInputComponent.prototype.loadTable = function (args, uiGridEditConstants) {
        var commonData = args.commonData, readOnly = args.readOnly, actionMenuItem = args.actionMenuItem, data = args.config.data;
        this.username = data.user;
        this.readonly = readOnly;
        if (commonData) {
            var nodeID = data.nodeID, nodeName = data.nodeName, tableDefn = data.tableDefn;
            this.tableDef = tableDefn[0];
            var _a = this.tableDef, Inherited = _a.Inherited, InputType = _a.InputType;
            this.tableDef.Inherited = Inherited && InputType === 'INHERITED';
            this.node = { _id: nodeID, name: nodeName };
            this.initComments(this.tableDef.Comment);
            this.tableInput = new table_input_logic_1["default"](this.node, this.tableDef, null, null);
            this.gridOptions = this.tableInput.getGridOptions(this.readonly, uiGridEditConstants, this.showAlert);
        }
        else {
            var node = args.node, compareToNode = args.compareToNode;
            this.node = node;
            var main = data.main, sibling = data.sibling, settings = data.settings;
            if (!this.verifyTemplateAndNode(main, sibling)) {
                return;
            }
            this.readonly = this.readonly || main.readOnly;
            this.tableDef = main.tableDef;
            var mainTable = main.tableDef;
            var siblingTable = sibling ? sibling.tableDef : null;
            if (siblingTable) {
                var shiftedSiblingTableVal = angular.copy(siblingTable['Val']);
                var diff = mainTable['Val']['ColHeaders'][0] - siblingTable['Val']['ColHeaders'][0];
                if (!isNaN(diff)) {
                    if (diff > 0) {
                        for (var i = 0; i < diff; i++) {
                            shiftedSiblingTableVal['ColHeaders'].push('N/A');
                            shiftedSiblingTableVal['Data'].forEach(function (row) {
                                row.shift();
                                row.push('N/A');
                            });
                        }
                    }
                    else if (diff < 0) {
                        for (var i = 0; i < Math.abs(diff); i++) {
                            shiftedSiblingTableVal['ColHeaders'].pop();
                            shiftedSiblingTableVal['Data'].forEach(function (row) {
                                row.unshift('N/A');
                                row.pop();
                            });
                        }
                    }
                    siblingTable['Val'] = shiftedSiblingTableVal;
                }
            }
            this.initComments(this.tableDef.Comment);
            this.title = actionMenuItem + " for " + node.name;
            this.tableInput = new table_input_logic_1["default"](node, mainTable, compareToNode, siblingTable);
            this.gridOptions = this.tableInput.getGridOptions(this.readonly, uiGridEditConstants, this.showAlert);
            var mainReference = main.referenceData;
            var siblingReference = sibling ? sibling.referenceData : {};
            var decimals = (0, basic_table_component_1.loadSettings)(args.treeName, settings).decimals;
            this.referenceData = (0, table_input_logic_1.getReferenceData)(mainReference, siblingReference, decimals);
        }
        this.commentDisabled = (this.isCommonData && this.tableDef.InputType === 'INHERITED') ||
            (!this.isCommonData && this.tableDef.Inherited);
    };
    TableInputComponent.prototype.decode = function (string) {
        try {
            return decodeURIComponent(string);
        }
        catch (e) {
            return string;
        }
    };
    TableInputComponent.prototype.initComments = function (comments) {
        this.commentHistory = comments;
        if (this.commentHistory && this.commentHistory.length > 0) {
            var _a = this.commentHistory[this.commentHistory.length - 1], SavedBy = _a.SavedBy, SavedOn = _a.SavedOn, msg = _a.msg, universalTableComment = _a.universalTableComment;
            var decodedMsg = this.decode(msg);
            this.currentComment = {
                savedBy: SavedBy,
                savedOn: SavedOn,
                msg: decodedMsg,
                originMsg: decodedMsg,
                universalTableComment: universalTableComment
            };
        }
        else {
            this.currentComment = { msg: '', originMsg: '', universalTableComment: '' };
        }
    };
    TableInputComponent.prototype.cleanup = function () {
        if (this.tableInput && this.tableInput.onDestroy) {
            this.tableInput.onDestroy();
        }
        this.tableInput = {};
        this.errMessage = null;
        this.commentHistory = null;
        this.currentComment = { msg: '', originMsg: '' };
        this.tableDef = null;
        this.title = '';
        this.saving = false;
        if (this.gridOptions) {
            this.gridOptions = null;
        }
    };
    TableInputComponent.prototype.verifyTemplateAndNode = function (main, sibling) {
        if (!main || !sibling) {
            this.errMessage = null;
            return true;
        }
        if (main.leafOrPlatform !== sibling.leafOrPlatform) {
            var nodeTypeStr = main.leafOrPlatform === 'leaf' ? 'basic' : 'platform';
            this.errMessage = 'Compare Inputs are only available for the same kind of nodes. ' +
                ("The selected node is a " + nodeTypeStr + " node, ") +
                ("it can only be compared with another " + nodeTypeStr + " node.");
            return false;
        }
        if (main.template !== sibling.template) {
            this.errMessage = 'Compare Table Inputs are only available for ' +
                'the same templates. ' +
                'Selected nodes are using different templates. ';
            return false;
        }
        return true;
    };
    TableInputComponent.prototype.override = function () {
        this.overrideInput({
            targetNodeId: this.node._id,
            sourceNodeId: this.tableDef.rootID,
            inputKey: this.tableDef.Key
        });
    };
    TableInputComponent.prototype.deOverride = function () {
        if (!confirm("De-Override will erase all the input data. Do you want to proceed?")) {
            return;
        }
        this.deoverrideInput({
            targetNodeId: this.node._id,
            inputKey: this.tableDef.Key
        });
        this.reset();
    };
    TableInputComponent.prototype.afterSave = function (newComment) {
        var _this = this;
        this.tableInput.data.forEach(function (row) {
            _this.tableInput.colHeaders.forEach(function (h) {
                if (!h.isHeaderColumn) {
                    var cell = row[h.field];
                    cell.originValue = cell.value;
                }
            });
        });
        if (!this.commentHistory) {
            this.commentHistory = [];
        }
        this.commentHistory.push(newComment);
        this.reset();
        this.initComments(this.commentHistory);
    };
    TableInputComponent.prototype.save = function () {
        var _this = this;
        this.saving = true;
        var d = new Date();
        var saveOn = d.toDateString().substring(0, d.toDateString().length - 4) +
            d.toTimeString().split(' ')[0] + " " + d.getFullYear();
        var newComment = {
            SavedBy: this.username,
            SavedOn: saveOn,
            lastVal: __assign(__assign({}, this.tableDef.Val), { Data: this.tableInput.originData }),
            msg: this.currentComment.msg
        };
        var newData = this.tableInput.generateDataForSaving();
        var tableDefCopy = __assign(__assign({}, this.tableDef), { Comment: [newComment], Val: __assign(__assign({}, this.tableDef.Val), { Data: newData }) });
        var isTableDataChanged = this.tableInput.isDirty;
        this.smartorg.saveInputs(this.node._id, [tableDefCopy]).then(function (ret) {
            _this.saving = false;
            if (ret && ret.msg && ret.msg.toUpperCase().startsWith('ERROR')) {
                _this.showAlert('danger', "Error!", ret.msg);
            }
            else {
                _this.afterSave(newComment);
                _this.tableInput.saveToOrigin(newData);
                _this.showAlert('success', "Saved!", ret.msg);
                if (_this.commonDataSaveCallback) {
                    _this.commonDataSaveCallback();
                }
                _this.lastUpdated();
                if (isTableDataChanged) {
                    _this.updateNodeIsDataValid();
                }
            }
        })["catch"](function (err) {
            _this.saving = false;
            _this.showAlert('danger', "Error!", err);
        });
    };
    TableInputComponent.prototype.reset = function () {
        this.tableInput.reset();
        this.currentComment.msg = this.currentComment.originMsg;
    };
    TableInputComponent.prototype.exportCSV = function () {
        return this.tableInput.toCSV('NA');
    };
    TableInputComponent.prototype.exportCSVEU = function () {
        return this.tableInput.toCSV('EU');
    };
    TableInputComponent.prototype.getMenu = function () {
        var ctrl = this;
        return [{
                'name': 'Save',
                'class': 'btn btn-xs btn-danger',
                'show': function () {
                    var dirty = !ctrl.destroyed && ((ctrl.tableInput && ctrl.tableInput.isDirty && ctrl.tableInput.isValid) ||
                        (ctrl.currentComment && ctrl.currentComment.msg !== ctrl.currentComment.originMsg));
                    return !ctrl.saving && dirty;
                },
                'callback': function () {
                    ctrl.save();
                }
            }, {
                'name': 'Reset',
                'class': 'btn btn-xs btn-primary',
                'show': function () {
                    var dirty = !ctrl.destroyed && ((ctrl.tableInput && ctrl.tableInput.isDirty) ||
                        (ctrl.currentComment && ctrl.currentComment.msg !== ctrl.currentComment.originMsg));
                    ctrl.setGlobalDirty(dirty);
                    return !ctrl.saving && dirty;
                },
                'callback': function () {
                    ctrl.reset();
                }
            }, {
                'name': '',
                'class': 'btn btn-xs btn-danger',
                'icon': 'fa fa-spinner fa-spin fa-fw',
                'show': function () {
                    return ctrl.saving;
                }
            }, {
                'name': 'Export',
                'items': [{
                        'name': 'Table',
                        'callback': function () {
                            var csvData = ctrl.exportCSV();
                            Common.downloadCSV(csvData, ctrl.title);
                        }
                    }, {
                        'name': 'Table EU',
                        'callback': function () {
                            var csvData = ctrl.exportCSVEU();
                            Common.downloadCSV(csvData, ctrl.title);
                        }
                    }]
            }];
    };
    return TableInputComponent;
}());
angular.module(COMPONENT_NAME, [
    'ui.grid',
    'ui.grid.pinning',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'ui.grid.moveColumns',
    'ui.grid.edit',
    'ui.grid.cellNav',
    history_modal_component_1["default"],
    so_rich_text_box_component_1["default"],
]).component('tableInput', {
    template: require('./table-input.component.html'),
    bindings: {
        smartorg: '=?',
        overrideInput: '&?',
        deoverrideInput: '&?',
        menu: '=',
        isCommonData: '@?',
        commonDataSaveCallback: '&?'
    },
    controller: TableInputComponent
});
exports["default"] = COMPONENT_NAME;
//# sourceMappingURL=table-input.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/table-input2/table-input.component.js